module.exports = __webpack_public_path__ + "img/41_01_005_194.9c0a4e7c.jpg";